// extracted by mini-css-extract-plugin
export default {"container":"ZjBI9","link":"jhko7","logo":"F06zX","content":"jyDTx","text":"pxCkY","button":"eiwJt"};